module.exports = __webpack_public_path__ + "img/19.5f57e65a.png";